/**
 * Labstep
 *
 * @module components/SignatureRequest/Action/Delete
 * @desc Action to delete
 */

import { EntityActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import type React from 'react';
import type { ISignatureRequestActionDeleteProps } from './types';

export const SignatureRequestActionDelete: React.FC<
  ISignatureRequestActionDeleteProps
> = ({ signatureRequest, ...rest }) => (
  <EntityActionDelete {...rest} entity={signatureRequest} />
);
